{
    "Accessibility menu": "منوی دسترسی",
    "Close": "بستن",
    "Text and Reading": "متن و خواندن",
    "Navigation and Interaction": "پیمایش و تعامل",
    "Text Align": "تراز متن",
    "Align Left": "تراز به چپ",
    "Align Center": "تراز وسط",
    "Align Right": "تراز راست",
    "Adjust Font Size": "تنظیم اندازه فونت",
    "Highlight Title": "برجسته کردن عنوان",
    "Highlight Links": "برجسته کردن لینک‌ها",
    "Readable Font": "فونت خوانا",
    "Color and Contrast": "رنگ و کنتراست",
    "Dark Contrast": "کنتراست تیره",
    "Light Contrast": "کنتراست روشن",
    "High Contrast": "کنتراست بالا",
    "High Saturation": "اشباع بالا",
    "Low Saturation": "اشباع پایین",
    "Monochrome": "تک‌رنگ",
    "Tools": "ابزارها",
    "Reading Guide": "راهنمای خواندن",
    "Big Cursor": "نشانگر بزرگ",
    "Increase Font Size": "افزایش اندازه فونت",
    "Decrease Font Size": "کاهش اندازه فونت",
    "Letter Spacing": "فاصله بین حروف",
    "Line Height": "ارتفاع خط",
    "Font Weight": "وزن فونت",
    "Dyslexia Font": "فونت دیسلکسیا",
    "Language": "زبان",
    "Accessibility widget": "بازکردن منوی دسترسی",
    "Accessibility Profiles": "پروفایل‌های دسترسی",
    "Cognitive Disability": "ناتوانی شناختی",
    "Seizure Safe": "ایمن برای صرع",
    "Accessibility statement": "بیانیه دسترسی",
    "ADHD": "بیش‌فعالی و کم‌توجهی",
    "Low Vision": "کم‌بینایی",
    "Pause Animations": "توقف انیمیشن‌ها",
    "Animation paused": "انیمیشن متوقف شد",
    "Reset all settings": "بازنشانی تنظیمات",
    "Shortcut:": "میان‌بر:",
    "Epilepsy Safe Mode": "حالت ایمن برای صرع",
    "Mute sounds": "بی‌صدا کردن صداها",
    "Page read": "خواندن صفحه",
    "Page read controls": "کنترل‌های خواندن صفحه",
    "Pause": "توقف موقت",
    "Resume": "ادامه",
    "Stop": "توقف",
    "Settings": "تنظیمات",
    "Speed": "سرعت",
    "Voice": "صدا",
    "Close accessibility menu": "بستن منوی دسترسی",
    "Back to accessibility menu": "بازگشت به منوی دسترسی",
    "Search languages": "جستجوی زبان‌ها",
    "Selected language": "زبان انتخاب‌شده",
    "View accessibility statement (opens in new window)": "مشاهده بیانیه دسترسی (در پنجره جدید باز می‌شود)",
    "Visit CookieYes website (opens in new window)": "بازدید از وب‌سایت CookieYes (در پنجره جدید باز می‌شود)",
    "Reset all accessibility settings to default": "بازنشانی همه تنظیمات دسترسی به حالت پیش‌فرض"
}
